import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Editor from "../components/Editor";
import StoryPhotoUpload from "../components/StoryPhotoUpload";
import bannerImg from "../assets/images/new-home-page-img.png";
import { apiUrl } from "../config/Config";

const KidsStory = () => {

  // ==================================================
  // USER DATA
  // ==================================================

  const customerdata = useSelector(
    (store) => store.userReducer.customerdata
  );

  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  // ==================================================
  // STATES
  // ==================================================

  const [language, setLanguage] = useState("en");
  const [title, setTitle] = useState("");
  const [name, setName] = useState("");
  const [storyText, setStoryText] = useState("");
  const [photos, setPhotos] = useState([]);
  const [editorLoaded, setEditorLoaded] = useState(true);
  const [showloading, setshowloading] = useState(false);

  const [errortitlemessage, seterrortitlemessage] = useState("");
  const [errornamemessage, seterrornamemessage] = useState("");
  const [errorstorytext, seterrorstorytext] = useState("");

  // ==================================================
  // LANGUAGE CHANGE
  // ==================================================

  const handleLanguageChange = (e) => {
    i18n.changeLanguage(e.target.value);
    setLanguage(e.target.value);
  };

  // ==================================================
  // SUBMIT
  // ==================================================

  const handleSubmit = async () => {

    let isError = false;

    if (title.trim()) {
      seterrortitlemessage("");
    } else {
      seterrortitlemessage(
        "Title of the story cannot be empty."
      );
      isError = true;
    }

    if (name.trim()) {
      seterrornamemessage("");
    } else {
      seterrornamemessage(
        "Name cannot be empty."
      );
      isError = true;
    }

    if (storyText.trim()) {
      seterrorstorytext("");
    } else {
      seterrorstorytext(
        "Story text is mandatory."
      );
      isError = true;
    }

    if (isError) {
      return;
    }

    const formData = new FormData();

    formData.append("type", "kids");
    formData.append("storytype", "textbased");
    formData.append("language", language);
    formData.append("title", title);
    formData.append("name", name.trim());
    formData.append("storyText", storyText);
    formData.append("hide_author", "false");
    photos.forEach((photo) => formData.append("photos[]", photo));

    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + customerdata?.token,
      },
    };

    try {

      setshowloading(true);

      const response = await axios.post(
        apiUrl + "createstory",
        formData,
        headers
      );

      if (response.data.status === "success") {
        navigate("/allstory");
      } else {
        alert(response.data.message || "Unable to submit story");
      }

    } catch (error) {

      console.error(
        "Kids story error:",
        error
      );

      alert(error.response?.data?.message || error.message);
    } finally {
      setshowloading(false);
    }
  };

  useEffect(() => {
    if (!customerdata || Object.keys(customerdata).length === 0) {
      navigate("/login");
      return;
    }

    if (customerdata.payment_status !== "completed") {
      alert("Please complete payment before writing a story");
      navigate("/");
    }
  }, [customerdata, navigate]);

  // ==================================================
  // UI
  // ==================================================

  return (

    <div className="kids-story-page">

      {/* =================================================
          FULL PAGE BACKGROUND ANIMATION
      ================================================= */}

      <div className="kids-page-animation">

        {/* Stars */}

        <span className="kids-page-star page-star-1">
          ⭐
        </span>

        <span className="kids-page-star page-star-2">
          ✨
        </span>

        <span className="kids-page-star page-star-3">
          🌟
        </span>

        <span className="kids-page-star page-star-4">
          ✨
        </span>

        <span className="kids-page-star page-star-5">
          ⭐
        </span>

        <span className="kids-page-star page-star-6">
          💫
        </span>


        {/* Bubbles */}

        <span className="kids-bubble bubble-1"></span>
        <span className="kids-bubble bubble-2"></span>
        <span className="kids-bubble bubble-3"></span>
        <span className="kids-bubble bubble-4"></span>
        <span className="kids-bubble bubble-5"></span>


        {/* Clouds */}

        <span className="kids-page-cloud page-cloud-1">
          ☁️
        </span>

        <span className="kids-page-cloud page-cloud-2">
          ☁️
        </span>


        {/* Small Page Butterflies */}

        <span className="page-flying-butterfly page-butterfly-1">
          🦋
        </span>

        <span className="page-flying-butterfly page-butterfly-2">
          🦋
        </span>

      </div>


      {/* =================================================
          BANNER
      ================================================= */}

      <section className="home-main-sec kids-story-banner">

        <img
          src={bannerImg}
          className="home-main-sec-bg"
          alt="Kids Story Banner"
        />

        <div className="home-main-sec-overlay"></div>


        {/* =================================================
            BANNER ANIMATION
        ================================================= */}

        <div className="kids-banner-animation">

          {/* Stars */}

          <span className="kids-banner-star banner-star-1">
            ⭐
          </span>

          <span className="kids-banner-star banner-star-2">
            ✨
          </span>

          <span className="kids-banner-star banner-star-3">
            🌟
          </span>

          <span className="kids-banner-star banner-star-4">
            💫
          </span>


          {/* Clouds */}

          <span className="kids-banner-cloud banner-cloud-1">
            ☁️
          </span>

          <span className="kids-banner-cloud banner-cloud-2">
            ☁️
          </span>


          {/* =================================================
              FLYING BUTTERFLIES
          ================================================= */}




          {/* Sparkles */}

          <span className="banner-sparkle sparkle-1">
            ✨
          </span>

          <span className="banner-sparkle sparkle-2">
            ✨
          </span>

          <span className="banner-sparkle sparkle-3">
            ✨
          </span>

        </div>


        {/* =================================================
            BANNER HEADING
        ================================================= */}

        <div className="container home-main-sec-content">

          <h1 className="loop-title">
            Create Your Motivational Story
          </h1>

        </div>

      </section>


      {/* =================================================
          FORM WRAPPER
      ================================================= */}

      <div className="kids-form-wrapper">


        {/* =================================================
            LEFT DECORATIONS
        ================================================= */}

        <div className="kids-form-left-decoration">

          <span className="form-deco-star form-star-1">
            ⭐
          </span>

          <span className="form-deco-star form-star-2">
            ✨
          </span>

          <span className="form-deco-star form-star-3">
            🌟
          </span>

          <span className="form-deco-cloud form-cloud-1">
            ☁️
          </span>

          <span className="form-deco-butterfly form-butterfly-1">
            🦋
          </span>

          <span className="form-deco-book form-book-1">
            📖
          </span>

        </div>


        {/* =================================================
            RIGHT DECORATIONS
        ================================================= */}

        <div className="kids-form-right-decoration">

          <span className="form-deco-star form-star-4">
            ✨
          </span>

          <span className="form-deco-star form-star-5">
            ⭐
          </span>

          <span className="form-deco-star form-star-6">
            🌟
          </span>

          <span className="form-deco-cloud form-cloud-2">
            ☁️
          </span>

          <span className="form-deco-butterfly form-butterfly-2">
            🦋
          </span>

          <span className="form-deco-book form-book-2">
            📚
          </span>

        </div>


        {/* =================================================
            CREATE STORY FORM
        ================================================= */}

        <div className="create-story-container">

          <h2 className="create-story-header">
            🧒 Create Your Story
          </h2>


          <div className="create-story-form">

            {/* LANGUAGE */}

            <div className="create-story-group">

              <label>
                {t("language")}
              </label>

              <select
                value={language}
                onChange={handleLanguageChange}
                className="create-story-dropdown langauge-label"
              >

                <option value="en">
                  English
                </option>

                <option value="hi">
                  हिंदी
                </option>

              </select>

            </div>


            {/* TITLE */}

            <div className="create-story-group">

              <label>
                {t("title")} *
              </label>

              <input
                type="text"
                placeholder={
                  t("enterstorytitle") + "..."
                }
                value={title}
                onChange={(e) => {

                  setTitle(e.target.value);
                  seterrortitlemessage("");

                }}
                className="create-story-input"
              />

              {errortitlemessage && (

                <p className="register-error-message createstory-error-message">
                  {errortitlemessage}
                </p>

              )}

            </div>


            {/* NAME */}

            <div className="create-story-group">

              <label>
                Name *
              </label>

              <input
                type="text"
                placeholder="Enter your name..."
                  maxLength={255}
                value={name}
                onChange={(e) => {

                  setName(e.target.value);
                  seterrornamemessage("");

                }}
                className="create-story-input"
              />

              {errornamemessage && (

                <p className="register-error-message createstory-error-message">
                  {errornamemessage}
                </p>

              )}

            </div>


            {/* STORY */}

            <div className="create-story-group">

              <label>
                {t("writestory")} *
              </label>

              <Editor
                storyEditor
                value={storyText}
                onChange={(data) => {

                  setStoryText(data);
                  seterrorstorytext("");

                }}
                editorLoaded={editorLoaded}
              />

              {errorstorytext && (

                <p className="register-error-message createstory-error-message">
                  {errorstorytext}
                </p>

              )}

            </div>


            <StoryPhotoUpload photos={photos} onChange={setPhotos} />

            {/* SUBMIT */}

            <button
              type="button"
              className="create-story-submit-btn"
              onClick={handleSubmit}
              disabled={showloading}
            >
              {showloading ? "Submitting..." : "🌸 Submit Story"}
            </button>

          </div>

        </div>

      </div>

    </div>
  );
};

export default KidsStory;
